function accommodation(accommodationData) {
    const that = {};

    that.getName = function() {
        return Odigeo._.get(accommodationData, 'accommodationName');
    };

    that.getAddress = function() {
        return Odigeo._.get(accommodationData, 'address');
    };

    that.getCity = function() {
        return Odigeo._.get(accommodationData, 'city');
    };

    that.getCountryCode = function() {
        return Odigeo._.get(accommodationData, 'countryCode');
    };

    return that;
}

module.exports = accommodation;
